import queryString from 'query-string';
import {
  toCamelCase,
  toSnakeCase
} from '@justpark/helpers/src/caseConverter/caseConverter';
import type { Dayjs } from 'dayjs';

const buildSlugParams = (
  dates: {
    arriving: Dayjs,
    leaving?: Dayjs
  },
  isMonthly: boolean,
  monthlyDuration?: string | null,
  monthlyType?: string | null,
  locationId: number,
  isEvListing: boolean
): string => (caseConvert: 'camel' | 'snake' = 'camel') => {
  const { arriving, leaving } = dates;
  const transform = caseConvert === 'camel' ? toCamelCase : toSnakeCase;

  const leavingTimeParams = !isMonthly
    ? {
        endDate: leaving.format('YYYY-MM-DD'),
        endTime: leaving.format('HH:mm:ss')
      }
    : {
        monthlyDuration,
        monthlyType
      };

  const queryParams = {
    startDate: arriving.format('YYYY-MM-DD'),
    startTime: arriving.format('HH:mm:ss'),
    listingId: locationId,
    ...leavingTimeParams,
    ...(isEvListing && { ev: 1 })
  };

  return queryString.stringify(transform(queryParams));
};

export default buildSlugParams;
